import { Transaction } from './api';

interface TransactionHistory {
  transactions: Transaction[];
  lastUpdated: string;
}

class TransactionHistoryService {
  private static instance: TransactionHistoryService;
  private history: TransactionHistory = {
    transactions: [],
    lastUpdated: new Date().toISOString()
  };

  private constructor() {}

  public static getInstance(): TransactionHistoryService {
    if (!TransactionHistoryService.instance) {
      TransactionHistoryService.instance = new TransactionHistoryService();
    }
    return TransactionHistoryService.instance;
  }

  public addTransaction(transaction: Transaction): void {
    this.history.transactions.push(transaction);
    this.history.lastUpdated = new Date().toISOString();
    this.saveToLocalStorage();
  }

  public getTransactions(): Transaction[] {
    return this.history.transactions;
  }

  public getLastUpdated(): string {
    return this.history.lastUpdated;
  }

  private saveToLocalStorage(): void {
    try {
      localStorage.setItem('transactionHistory', JSON.stringify(this.history));
    } catch (error) {
      console.error('Failed to save transaction history:', error);
    }
  }

  public loadFromLocalStorage(): void {
    try {
      const savedHistory = localStorage.getItem('transactionHistory');
      if (savedHistory) {
        this.history = JSON.parse(savedHistory);
      }
    } catch (error) {
      console.error('Failed to load transaction history:', error);
    }
  }

  public clearHistory(): void {
    this.history.transactions = [];
    this.history.lastUpdated = new Date().toISOString();
    this.saveToLocalStorage();
  }
}

export default TransactionHistoryService;